import React from 'react'
import LoginBody from '../../components/logincomponents/LoginBody';



function FindJobPage({onLogin}) {
  const intendedUrl = localStorage.getItem("intendedUrl");
  localStorage.clear();
  if (intendedUrl) {
    localStorage.setItem("intendedUrl", intendedUrl);
  }
  return (
    <div>
     {/* <FindJobs /> */}
    <LoginBody handleLogin={onLogin}/>
    {/* <Footer /> */}
    </div>
  )
}
export default FindJobPage;